import React from 'react';
const CEODashboard = () => {
    return ( 
        <>
        <img src='/md.png' style={{"width":"100%"}}/>
        </>

     );
}
 
export default CEODashboard;